import React from 'react';
import '../App.css';
import { Route, Switch } from 'react-router';
import routes from '../routes/routes';

//----Include Fragment Pages-----
import MenuSection from '../fragment_folder/menus';
import TopHeaderPage from '../fragment_folder/topHeader';
import FooterPage from '../fragment_folder/footer';

//----Views----
import _admin_DashboardPanel from '../views_folder/administratorController/dashboard';
import _admin_profilePanel from '../views_folder/administratorController/profile/profile';
import _admin_countryPanel from '../views_folder/administratorController/country/manageCountry';
import _admin_gstTypePanel from '../views_folder/administratorController/masters/gstType';
import _admin_gstListPanel from '../views_folder/administratorController/masters/gst';
import _admin_unitListPanel from '../views_folder/administratorController/masters/unit';
import _admin_businessTypeListPanel from '../views_folder/administratorController/masters/businessType';
import _admin_businesscategoryListPanel from '../views_folder/administratorController/masters/businesscategory';
import _admin_BusinessListPanel from '../views_folder/administratorController/business/businessList';
import _admin_BusinessAddPanel from '../views_folder/administratorController/business/businessAdd';
import _admin_CompanyListPanel from '../views_folder/administratorController/company/companyList';
import _admin_CompanyAddPanel from '../views_folder/administratorController/company/companyAdd';
import _admin_BusinessUserListPanel from '../views_folder/administratorController/businessUser/manageBusinessUser';
import _admin_BlogPanel from '../views_folder/administratorController/blog/blogList';
import _admin_BlogAddPanel from '../views_folder/administratorController/blog/blogAdd';
import _admin_BlogCategoryPanel from '../views_folder/administratorController/blog/blogCategory';
import _admin_WebsitePlanPanel from '../views_folder/administratorController/websitePlan/websitePlan';
import _admin_WebsitePlanPricePanel from '../views_folder/administratorController/websitePlan/websitePlanPrice';
import _admin_BusinessSMSSetting from '../views_folder/administratorController/smsSetting/smsSettingList';
import _admin_BusinessPendingSMS from '../views_folder/administratorController/smsSetting/pendingSmsList';
import _admin_SetupAddPanel from '../views_folder/administratorController/masterSubscription/setupPlanAdd';
import _admin_SetupPanel from '../views_folder/administratorController/masterSubscription/setupPlanList';
import _admin_MasterAddPanel from '../views_folder/administratorController/masterSubscription/masterPlanAdd';
import _admin_MasterPanel from '../views_folder/administratorController/masterSubscription/masterPlanList';
import _admin_FeatureManager from '../views_folder/administratorController/masterSubscription/FeatureManager';


import useAutoLogout from './useAutoLogout';

export default function PrivatePanel() {
  // run idle logout
  useAutoLogout(); // defaults to 10 minutes

  return (
    <div id="page-wrapper">
      <div
        id="page-container"
        className="sidebar-o enable-page-overlay side-scroll page-header-modern main-content-boxed"
      >
        <MenuSection pageId={global.BACK_URL} />
        <TopHeaderPage />

        <main id="main-container">
          <div>
            <Switch>
              <Route exact path={routes._admin_DashboardPanel} component={_admin_DashboardPanel} />
              <Route exact path={routes._admin_profilePanel} component={_admin_profilePanel} />
              <Route exact path={routes._admin_countryPanel} component={_admin_countryPanel} />
              <Route exact path={routes._admin_gstTypePanel} component={_admin_gstTypePanel} />
              <Route exact path={routes._admin_gstListPanel} component={_admin_gstListPanel} />
              <Route exact path={routes._admin_unitListPanel} component={_admin_unitListPanel} />
              <Route exact path={routes._admin_businessTypeListPanel} component={_admin_businessTypeListPanel} />
              <Route exact path={routes._admin_businesscategoryListPanel} component={_admin_businesscategoryListPanel} />
              <Route exact path={routes._admin_BusinessListPanel} component={_admin_BusinessListPanel} />
              <Route exact path={routes._admin_BusinessAddPanel} component={_admin_BusinessAddPanel} />
              <Route exact path={routes._admin_CompanyListPanel} component={_admin_CompanyListPanel} />
              <Route exact path={routes._admin_CompanyAddPanel} component={_admin_CompanyAddPanel} />
              <Route exact path={routes._admin_BusinessUserListPanel} component={_admin_BusinessUserListPanel} />
              <Route exact path={routes._admin_BlogPanel} component={_admin_BlogPanel} />
              <Route exact path={routes._admin_BlogAddPanel} component={_admin_BlogAddPanel} />
              <Route exact path={routes._admin_BlogCategoryPanel} component={_admin_BlogCategoryPanel} />
              <Route exact path={routes._admin_WebsitePlanPanel} component={_admin_WebsitePlanPanel} />
              <Route exact path={routes._admin_WebsitePlanPricePanel} component={_admin_WebsitePlanPricePanel} />
              <Route exact path={routes._admin_BusinessSMSSetting} component={_admin_BusinessSMSSetting} />
              <Route exact path={routes._admin_BusinessPendingSMS} component={_admin_BusinessPendingSMS} />
              <Route exact path={routes._admin_SetupAddPanel} component={_admin_SetupAddPanel} />
              <Route exact path={routes._admin_SetupPanel} component={_admin_SetupPanel} />
              <Route exact path={routes._admin_MasterAddPanel} component={_admin_MasterAddPanel} />
              <Route exact path={routes._admin_MasterPanel} component={_admin_MasterPanel} />
              <Route exact path={routes._admin_FeatureManager} component={_admin_FeatureManager} />
            </Switch>
          </div>
        </main>

        <FooterPage />
      </div>
    </div>
  );
}